(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauchi-cart-addons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-mauchi-cart-addons]');
    if (!root) return;
    var protId = root.dataset.protId ? Number(root.dataset.protId) : 0;
    var autoApply = root.dataset.autoApply === 'true';
    var DECLINE_KEY = 'mauchiProtDeclined';

    var protToggle = root.querySelector('[data-mauchi-prot-toggle]');
    var reelToggle = root.querySelector('[data-mauchi-reel-toggle]');

    function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
    function addProt() {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: protId, quantity: 1 }] }) });
    }
    function removeProt() {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(protId), quantity: 0 }) });
    }
    function setAttr(v) {
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'UGC-Video-Deal': v } }) });
    }

    getCart().then(function (cart) {
      var hasProt = protId && cart.items.some(function (i) { return i.variant_id === protId || i.id === protId; });
      var declined = false;
      try { declined = localStorage.getItem(DECLINE_KEY) === '1'; } catch (e) {}

      if (protToggle) {
        if (!hasProt && autoApply && !declined && cart.items.length) {
          // auto-apply once
          addProt().then(function () { window.location.reload(); });
          protToggle.checked = true;
        } else {
          protToggle.checked = hasProt;
        }
        protToggle.addEventListener('change', function () {
          if (protToggle.checked) {
            try { localStorage.removeItem(DECLINE_KEY); } catch (e) {}
            addProt().then(function () { window.location.reload(); });
          } else {
            try { localStorage.setItem(DECLINE_KEY, '1'); } catch (e) {}
            removeProt().then(function () { window.location.reload(); });
          }
        });
      }

      if (reelToggle) {
        var attrs = cart.attributes || {};
        reelToggle.checked = attrs['UGC-Video-Deal'] === 'yes';
        reelToggle.addEventListener('change', function () {
          setAttr(reelToggle.checked ? 'yes' : '');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauchi-cart-sync"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mauchiCartSyncBound) return;
    window.__mauchiCartSyncBound = true;

    var DECLINE_KEY = 'mauchiProtDeclined';
    var PROT_HANDLE = 'paketschutz';
    var SOURCE = 'mauchi-cart-sync';
    var protIdPromise = null;
    var busy = false;
    var suppressObserver = false;

    function getProtId() {
      if (!protIdPromise) {
        protIdPromise = fetch('/products/' + PROT_HANDLE + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { return p ? p.variants[0].id : null; })
          .catch(function () { return null; });
      }
      return protIdPromise;
    }

    function getCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }

    // The section ids the theme's own cart components render into. Asking
    // Shopify to return this markup alongside the mutation lets us hand real
    // HTML to <cart-items-component>, which then MORPHS it. Without it the
    // component falls back to a full re-render that tears down the open
    // <dialog> — that is what used to slam the cart drawer shut on untick.
    function cartSectionIds() {
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        var id = el.dataset.sectionId;
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
      return ids;
    }

    function post(url, payload) {
      var ids = cartSectionIds();
      if (ids.length) {
        payload.sections = ids.join(',');
        payload.sections_url = window.location.pathname;
      }
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      }).then(function (r) { return r.json().catch(function () { return null; }); });
    }

    // Idempotent on purpose: /cart/add.js INCREMENTS, so an auto-apply landing
    // at the same moment as a manual tick used to leave protection at qty 2 and
    // double-charge. Always settle on exactly one.
    function addProt(id) {
      return getCart().then(function (cart) {
        var line = null;
        (cart && cart.items ? cart.items : []).forEach(function (i) {
          if (i.variant_id === id || i.id === id) line = i;
        });
        if (!line) return post('/cart/add.js', { items: [{ id: id, quantity: 1 }] });
        if (line.quantity !== 1) return post('/cart/change.js', { id: String(id), quantity: 1 });
        return null;
      });
    }
    function removeProt(id) { return post('/cart/change.js', { id: String(id), quantity: 0 }); }
    function setUgcAttr(v) { return post('/cart/update.js', { attributes: { 'UGC-Video-Deal': v } }); }

    // ---- cart count that ignores the protection add-on ----------------------
    function protQty(cart) {
      var n = 0;
      (cart && cart.items ? cart.items : []).forEach(function (i) {
        if (i.handle === PROT_HANDLE || (i.product_handle && i.product_handle === PROT_HANDLE)) n += i.quantity;
      });
      return n;
    }

    function visibleCount(cart) {
      if (!cart) return 0;
      var n = (cart.item_count || 0) - protQty(cart);
      return n < 0 ? 0 : n;
    }

    function paintBubble(n) {
      document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
        el.textContent = n < 100 ? String(n) : '';
        el.classList.toggle('hidden', n === 0);
      });
      document.querySelectorAll('.cart-bubble').forEach(function (el) {
        el.classList.toggle('visually-hidden', n === 0);
      });
    }

    function syncBubble() {
      return getCart().then(function (cart) {
        paintBubble(visibleCount(cart));
        return cart;
      }).catch(function () {});
    }

    // ---- hand rendering back to the theme (keeps the drawer open) -----------
    function drawerIsOpen() {
      return !!document.querySelector('cart-drawer-component dialog[open]');
    }

    // If anything still manages to close the drawer, put it back. Cheap
    // insurance so the shopper never gets bounced out of the cart mid-toggle.
    function keepDrawerOpen(wasOpen) {
      if (!wasOpen) return;
      [120, 400, 700].forEach(function (delay) {
        setTimeout(function () {
          if (drawerIsOpen()) return;
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.showDialog === 'function') {
            try { drawer.showDialog(); } catch (e) {}
          }
        }, delay);
      });
    }

    function repaint(res) {
      suppressObserver = true;
      var wasOpen = drawerIsOpen();
      return getCart().then(function (cart) {
        var n = visibleCount(cart);
        try {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                source: SOURCE,
                itemCount: n,
                // Real markup => the component morphs instead of re-rendering.
                sections: res && res.sections ? res.sections : undefined,
              },
            },
          }));
        } catch (e) {}
        keepDrawerOpen(wasOpen);
        paintBubble(n);
        // The theme re-renders asynchronously; re-assert afterwards so a
        // freshly rendered bubble can't put the raw count back.
        setTimeout(function () { paintBubble(n); }, 350);
        busy = false;
        setTimeout(function () { suppressObserver = false; }, 800);
      }).catch(fail);
    }

    function fail() {
      busy = false;
      suppressObserver = false;
    }

    function autoApplyProtection() {
      if (busy) return;
      var declined = false;
      try { declined = localStorage.getItem(DECLINE_KEY) === '1'; } catch (e) {}
      if (declined) return;
      Promise.all([getProtId(), getCart()]).then(function (r) {
        var id = r[0];
        var cart = r[1];
        if (!id || !cart || !cart.items || !cart.items.length) return;
        // Protection alone in the cart is not a reason to keep it.
        if (visibleCount(cart) === 0) return;
        var has = cart.items.some(function (i) { return i.variant_id === id || i.id === id; });
        if (!has && !busy) {
          busy = true;
          addProt(id).then(repaint).catch(fail);
        }
      });
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;

      if (t.matches('[data-mauchi-prot]')) {
        if (busy) return;
        var wantChecked = t.checked;
        getProtId().then(function (id) {
          if (!id) return;
          busy = true;
          document.querySelectorAll('[data-mauchi-prot]').forEach(function (x) { x.checked = wantChecked; });
          if (wantChecked) {
            try { localStorage.removeItem(DECLINE_KEY); } catch (e2) {}
            addProt(id).then(repaint).catch(fail);
          } else {
            // Flag the decline BEFORE removing, so the observer-driven
            // auto-apply cannot race in and re-add what we just removed.
            try { localStorage.setItem(DECLINE_KEY, '1'); } catch (e2) {}
            removeProt(id).then(repaint).catch(fail);
          }
        });
        return;
      }

      if (t.matches('[data-mauchi-ugc]')) {
        var on = t.checked;
        document.querySelectorAll('[data-mauchi-ugc]').forEach(function (x) { x.checked = on; });
        setUgcAttr(on ? 'Ja' : '').catch(function () {});
      }
    });

    // Cart changed somewhere else in the theme: re-check protection, and make
    // sure the bubble still hides the add-on.
    document.addEventListener('cart:update', function (e) {
      if (e && e.detail && e.detail.data && e.detail.data.source === SOURCE) return;
      setTimeout(syncBubble, 80);
      autoApplyProtection();
    });
    ['cart:add', 'cart:change'].forEach(function (name) {
      document.addEventListener(name, function () {
        setTimeout(syncBubble, 80);
        autoApplyProtection();
      });
    });

    var moTimer = null;
    var mo = new MutationObserver(function () {
      if (suppressObserver) return;
      clearTimeout(moTimer);
      moTimer = setTimeout(function () {
        if (suppressObserver) return;
        if (document.querySelector('[data-mauchi-prot]')) autoApplyProtection();
      }, 400);
    });
    mo.observe(document.body, { childList: true, subtree: true });

    syncBubble();
    autoApplyProtection();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauchi-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-mauchi-popup]');
    if (!root) return;
    var KEY_DONE = 'mauchiPopupDone';
    var KEY_SNOOZE = 'mauchiPopupSnooze';
    var KEY_WIN = 'mauchiPopupWin';
    var CODES = { 5: 'MAUCHI5', 10: 'MAUCHI10', 12: 'MAUCHI12' };
    var APPLY_REDIRECT = '/collections/all';

    function show(step) {
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      root.querySelectorAll('[data-mauchi-popup-step]').forEach(function (s) {
        s.hidden = s.dataset.mauchiPopupStep !== step;
      });
    }
    var closeTimer = null;
    function hide() {
      var finish = function () {
        root.hidden = true;
        root.classList.remove('is-closing');
        document.documentElement.style.overflow = '';
      };
      if (root.hidden || root.classList.contains('is-closing')) { return; }
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { finish(); return; }
      root.classList.add('is-closing');
      clearTimeout(closeTimer);
      closeTimer = setTimeout(finish, 220);
    }
    root.querySelectorAll('[data-mauchi-popup-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        hide();
        try { localStorage.setItem(KEY_SNOOZE, String(Date.now())); } catch (e) {}
      });
    });

    // ---- the game ----
    var game = root.querySelector('[data-mauchi-game]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mauchi-card]'));
    var tags = root.querySelector('[data-mauchi-popup-tags]');
    var claim = root.querySelector('[data-mauchi-claim]');
    var wonText = root.querySelector('[data-mauchi-won]');
    var gameSub = root.querySelector('[data-mauchi-game-sub]');

    // Each box gets its own hidden prize (5 / 10 / 12 %). Only the box the
    // customer taps is revealed; the rest stay unchanged as "?".
    var PRIZES = [5, 10, 12];
    cards.forEach(function (card) {
      card.classList.add('is-idle');
      var pct = PRIZES[Math.floor(Math.random() * PRIZES.length)];
      card.dataset.pct = pct;
      card.querySelector('[data-mauchi-card-pct]').textContent = '−' + pct + '%';
    });

    var played = false;
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (played) return;
        played = true;
        var pct = Number(card.dataset.pct);
        game.classList.add('is-done');
        // reveal ONLY this box; leave the others exactly as they were
        card.classList.remove('is-idle');
        card.classList.add('is-flipped', 'is-winner');
        // guaranteed reveal (theme animation hijacks opacity, so toggle display)
        var frontEl = card.querySelector('.mauchi-gamecard__front');
        var backEl = card.querySelector('.mauchi-gamecard__back');
        if (frontEl) frontEl.style.display = 'none';
        if (backEl) backEl.style.display = 'flex';
        var code = CODES[pct];
        try { localStorage.setItem(KEY_WIN, String(pct)); } catch (e) {}
        if (tags) tags.value = 'newsletter,popup,win-' + pct;
        if (gameSub) gameSub.textContent = 'Deine Box ist geöffnet – sichere dir deinen Rabatt:';
        if (wonText) wonText.textContent = 'Du hast ' + pct + ' % Rabatt gewonnen! 🎉';
        if (claim) claim.hidden = false;
      });
    });

    root.querySelector('.mauchi-popup__form').addEventListener('submit', function () {
      try { localStorage.setItem(KEY_DONE, '1'); } catch (e) {}
    });

    // ---- success ----
    function showSuccess(pct) {
      var code = CODES[pct] || CODES[10];
      root.querySelector('[data-mauchi-popup-code]').textContent = code;
      root.querySelector('[data-mauchi-popup-apply]').href = '/discount/' + code + '?redirect=' + APPLY_REDIRECT;
      show('success');
    }
    var copyBtn = root.querySelector('[data-mauchi-popup-copy]');
    copyBtn.addEventListener('click', function () {
      var code = root.querySelector('[data-mauchi-popup-code]').textContent;
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject())
        .then(function () { copyBtn.textContent = 'Kopiert ✓'; })
        .catch(function () {});
    });

    // ---- entry ----
    var params = new URLSearchParams(location.search);
    var posted = params.get('customer_posted') === 'true' || params.get('mauchi_popup') === 'done';
    var done = null, snooze = 0, win = null;
    try {
      done = localStorage.getItem(KEY_DONE);
      snooze = Number(localStorage.getItem(KEY_SNOOZE) || 0);
      win = localStorage.getItem(KEY_WIN);
    } catch (e) {}

    if (posted && win) {
      showSuccess(Number(win));
      try { localStorage.removeItem(KEY_WIN); } catch (e) {}
    } else if (!done && Date.now() - snooze > 86400000) {
      setTimeout(function () { show('game'); }, Number(root.dataset.delay) || 5000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauchi-reviewbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mauchiTopOffsetBound) return;
    window.__mauchiTopOffsetBound = true;

    function measure() {
      var bar = document.querySelector('.mauchi-reviewbar');
      var header = document.querySelector('.header__columns');
      var barH = bar ? bar.getBoundingClientRect().height : 0;
      var headerH = header ? header.getBoundingClientRect().height : 0;
      var total = Math.round(barH + headerH);
      if (!total) return;
      document.documentElement.style.setProperty('--mauchi-top-offset', total + 'px');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', measure);
    } else {
      measure();
    }
    window.addEventListener('load', measure);
    window.addEventListener('resize', measure);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauchi-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var vids = document.querySelectorAll('[data-mauchi-video]');
    if (!vids.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting) {
              v.play().catch(function () {});
            } else {
              v.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      vids.forEach(function (v) { io.observe(v); });
    } else {
      vids.forEach(function (v) { v.play().catch(function () {}); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
